// <ConvexAuthBridge /> — captures useAuthActions into the module-level
// cell exposed by convexBridge.ts so lib/api.ts can drive Convex Auth
// from outside the React tree. Web counterpart of the mobile bridge.
// Mount inside ConvexAuthProvider in main.tsx. Renders null.

import { useAuthActions } from '@convex-dev/auth/react';
import { useEffect } from 'react';

import { setConvexAuthFns, type SignInFn, type SignOutFn } from './convexBridge';

export function ConvexAuthBridge(): null {
  const { signIn, signOut } = useAuthActions();
  useEffect(() => {
    setConvexAuthFns({
      signIn: signIn as unknown as SignInFn,
      signOut: signOut as unknown as SignOutFn,
    });
  }, [signIn, signOut]);
  return null;
}
